import { render, staticRenderFns } from "./EquipmentViewDetails.vue?vue&type=template&id=f36ca3f4&"
import script from "./EquipmentViewDetails.vue?vue&type=script&lang=js&"
export * from "./EquipmentViewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports